import VorQuestionsTable from "./VorQuestionsTableContainer";

export default VorQuestionsTable;
